import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { Fail } from '../asset';
import RequestActionDialogBase, {
  RequestActionDialogProps
} from './based/RequestActionDialogBase';

interface PreventEditDialogProps extends RequestActionDialogProps {
  onClose: () => void;
  description?: string;
}

const PreventEditDialog = ({
  open,
  onClose,
  description = '환불계좌 삭제가 불가능 합니다. \n 파트너와 거래를 완료하거나 거래취소를 진행해주세요.'
}: PreventEditDialogProps) => {
  return (
    <RequestActionDialogBase
      open={open}
      iconSrc={Fail}
      title={'진행 중인 거래 건이 있습니다'}
      description={description}
      ButtonComponent={
        <CustomizedButton
          onClick={onClose}
          variant="contained"
          color="secondary"
          size="large"
        >
          <CustomizedTypography variant="body1" fontWeight="500">
            확인
          </CustomizedTypography>
        </CustomizedButton>
      }
    />
  );
};

export default PreventEditDialog;
